import { Space } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";
export default function InfoCard({ children, className }) {
  return (
    <Space
      className={classNames([styles.infoCard, className])}
      direction={"vertical"}
      size={12}
    >
      {children}
    </Space>
  );
}

/**
 *
 * @param {{
 * label: string
 * value: string
 * justify: boolean
 * valueStyle: import("react").CSSProperties,
 * labelStyle: import("react").CSSProperties,,
 * }} props
 * @returns
 */
InfoCard.Item = function Item({
  label,
  value,
  justify, // 两端对齐
  valueStyle = {},
  labelStyle = {},
}) {
  return (
    <div className={styles.item}>
      <span
        className={styles.label + (justify ? " " + styles.justify : "")}
        style={labelStyle}
      >
        {label}
      </span>
      <span className={styles.value} style={valueStyle}>
        {value}
      </span>
    </div>
  );
};
